// 接口配置
// 服务器接口根地址
var config = require('../../config')
var isProduction = process.env.NODE_ENV === 'production'

export const SERVER_BASE_URL = isProduction ? config.build.baseServerUrl : config.dev.baseServerUrl
export const ERR_OK = 0
export const BAIDU_AK = "E6jZP5Q9GPxWTiQHAP5FWOsWPq5GyUll"




// WEBPACK FOOTER //
// ./src/api/config.js